<template>
  <div class="uk-margin-medium-top" uk-grid>
    <div class="uk-width-1-1">
      <Card removeHeaderDivider="true">
        <template v-slot:header>
          <div class="uk-flex">
            <h2 class="uk-display-inline">Invoices</h2>
            <a class="uk-icon-link ba-header-info" uk-icon="info" uk-tooltip="title: All invoices are automatically paid via your saved payment method on the due date; pos: right"></a>
          </div>

          <div class="uk-width-expand ba-remove-parent-header-padding">
            <div class="ba-card-header-tabs">
              <ul class="uk-flex-left uk-visible@m" uk-tab>
                <li @click="selected_filter = 'all'" :class="{'uk-active':selected_filter == 'all'}"><a>all</a></li>
                <li @click="selected_filter = 'unpaid'" :class="{'uk-active':selected_filter == 'unpaid'}"><a>unpaid</a></li>
                <li @click="selected_filter = 'paid'" :class="{'uk-active':selected_filter == 'paid'}"><a>paid</a></li>
              </ul>
            </div>
          </div>

        </template>

        <template v-slot:body>
          <div class="ba-height-min-large uk-flex uk-flex-middle" uk-grid v-if="invoices == null">
            <div class="uk-width-1-1">
              <div class="uk-text-center">
                <span uk-icon="icon: info; ratio: 5.25"></span>
                <h4 class="uk-h4 uk-text-muted">You don't have any invoices yet.</h4>
              </div>
            </div>
          </div>
          <div class="ba-height-min-large" v-else>
            <table class="uk-table uk-table-divider uk-table-hover uk-table-middle uk-table-large">
              <thead>
                <tr>
                  <th class="uk-width-small uk-text-center">Invoice #</th>
                  <th class="uk-width-small uk-text-center">Date Due</th>
                  <th class="uk-width-small uk-text-center">Amount</th>
                  <th class="uk-width-small uk-text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in filtered_invoices" :key="index">
                  <td class="uk-table-link uk-text-center">
                    <router-link class="uk-link-reset" :to="{ name: 'ViewInvoice', params: { id: invoice.id } }">{{ invoice.id }}</router-link>
                  </td>
                  <td class="uk-table-link uk-text-center">
                    <router-link class="uk-link-reset" :to="{ name: 'ViewInvoice', params: { id: invoice.id } }">{{ invoice.date_due | formatDate }}</router-link>
                  </td>
                  <td class="uk-table-link uk-text-center">
                    <router-link class="uk-link-reset" :to="{ name: 'ViewInvoice', params: { id: invoice.id } }">{{ invoice.total | formatCurrency }}</router-link>
                  </td>
                  <td class="uk-table-link uk-text-center">
                    <router-link class="uk-link-reset" :to="{ name: 'ViewInvoice', params: { id: invoice.id } }">{{ invoice.due == 0 ? 'paid' : 'unpaid' }}</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

      </Card>
    </div>
  </div>
</template>

<script>
import Card from '@/components/common/card.vue';

import { mapActions, mapState } from "vuex";

export default {
  name: 'Invoices',
  components: {
    Card,
  },
  data() {
    return {
      selected_filter: 'all'
    }
  },
  computed: {
    ...mapState('invoices', ['invoices']),
    filtered_invoices() {
      if(this.invoices.length == 0)
        return null
      else if(this.selected_filter == 'all')
        return this.invoices
      else {
        if( this.selected_filter == 'paid')
          return this.invoices.filter( (invoice) => invoice.due == 0 )
        else
          return this.invoices.filter( (invoice) => invoice.due != 0)
      }
    }
  },
  created() {
    this.GET_INVOICES();
  },
  methods: {
    ...mapActions('invoices', ['GET_INVOICES']),
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";

.uk-tab {
  margin: 0;
  border-bottom: 1px solid @ba-off-white;
  > * {
    > a {
      display: block;
      text-align: center;
      padding: 9px 20px;
      border-bottom: 2px solid transparent;
      font-size: 12px;
      text-transform: uppercase;
      transition: color .1s ease-in-out;
      line-height: 20px;
    }
  }
  > .uk-active {
    > a {
      color: #222;
      border-color: @ba-purple;
    }
  }
}
.uk-table {
  margin-top: 0;
}
.ba-remove-parent-header-padding {
  margin-left: -40px;
  margin-right: -40px;
  margin-bottom: -20px;
}
.ba-card-header-tabs {
  width: ~'calc(100% + 80px)';
}
.ba-header-info {
  padding-left: 15px;
  padding-top: 14px;
}
</style>
